import { FilterableList } from "./forms/FilterableList";
import { Grid } from "@mui/material";
import { ParticipantWithId } from "../../interfaces/IParticipants";
import { useMemo } from "react";

interface ParticipantsSelectorProps<T extends ParticipantWithId> {
  allItems: T[];
  selectedItems: T[];
  setSelectedItems: (items: T[]) => void;
  getLabel: (item: T) => string;
}

export function ParticipantsSelector<T extends ParticipantWithId>({
  allItems,
  selectedItems,
  setSelectedItems,
  getLabel,
}: ParticipantsSelectorProps<T>) {
  const handleToggleItem = (item: T) => {
    if (selectedItems.some((a) => a.id === item.id)) {
      setSelectedItems(selectedItems.filter((a) => a.id !== item.id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const sortedAvailableItems = useMemo(() => {
    return allItems
      .filter((item) => !selectedItems.some((a) => a.id === item.id))
      .sort((a, b) => compareParticipants(a, b));
  }, [allItems, selectedItems]);

  const sortedSelectedItems = useMemo(() => {
    return selectedItems.sort((a, b) => compareParticipants(a, b));
  }, [selectedItems]);

  function compareParticipants(a: ParticipantWithId, b: ParticipantWithId): number {
    if (a.lastName < b.lastName) return -1;
    if (a.lastName > b.lastName) return 1;
    if (a.firstName < b.firstName) return -1;
    if (a.firstName > b.firstName) return 1;
    return 0;
  }

  return (
    <Grid container spacing={2}>
      {/* Lista dostępnych uczestników */}
      <Grid item xs={12} md={6}>
        <FilterableList<T>
          items={sortedAvailableItems}
          onToggleItem={handleToggleItem}
          filterPlaceholder="Wyszukaj zawodnika"
          getLabel={getLabel}
          title="Dostępni zawodnicy"
          enableEnterAutoSelect
        />
      </Grid>

      {/* Lista wybranych uczestników */}
      <Grid item xs={12} md={6}>
        <FilterableList<T>
          items={sortedSelectedItems}
          onToggleItem={handleToggleItem}
          filterPlaceholder="Wyszukaj zawodnika"
          getLabel={getLabel}
          title="Wybrani zawodnicy (wymagane)"
        />
      </Grid>
    </Grid>
  );
}
